export default "__VITE_ASSET__DqxMiB9e__"